import React from "react";
import Icon, { type IconProps } from "./Icon";
/** Pencil — Lucide. https://lucide.dev/icons/pencil (MIT). Copied 2026-05-16.
 *  Phase 3d: AdminAudit user.update + state.partial.* edit markers. */
export default function Pencil(props: Omit<IconProps, "children">) {
  return (
    <Icon {...props}>
      <path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z" />
      <path d="m15 5 4 4" />
    </Icon>
  );
}
